/**
 * Extracted from `components/question-builder-primitives.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import { cn } from "@/lib/utils"

export function builderListIndexClass(size: 6 | 7 = 7) {
  return cn(
    "inline-flex shrink-0 items-center justify-center rounded-md border border-border bg-muted font-semibold text-foreground tabular-nums",
    size === 6 ? "size-6 text-xs" : "size-7 text-xs"
  )
}
